import { zonoApi } from '../api/zonoApi';
import {
  ContinueChatRequest,
  GetSurveyFormByIdRequest,
  GetSurveyFormByIdResponse,
  StartBotSessionRequest,
  SubmitSurveyFormRequest,
  SubmitSurveyFormResponse,
  SurveyFormAnswerByIdRequest,
  SurveyFormAnswerByIdResponse,
} from './survey-forms-model';

export const SurveyFormsApi = zonoApi.injectEndpoints({
  endpoints: (builder) => ({
    getSurveyFormById: builder.query<
      GetSurveyFormByIdResponse,
      GetSurveyFormByIdRequest
    >({
      query(arg) {
        return {
          url: `/hub/bot/api/v1/forms/${arg?.formId}`,
          params: arg?.params,
          method: 'GET',
        };
      },
    }),
    submitSurveyForm: builder.mutation<
      SubmitSurveyFormResponse,
      SubmitSurveyFormRequest
    >({
      query(arg) {
        return {
          url: `/hub/bot/api/v1/forms/${arg?.formId}/answers`,
          body: arg?.body,
          params: arg?.params,
          method: 'POST',
        };
      },
    }),
    getSurveyFormAnswerById: builder.query<
      SurveyFormAnswerByIdResponse,
      SurveyFormAnswerByIdRequest
    >({
      query(arg) {
        return {
          url: `/hub/bot/api/v1/forms/answers/${arg?.formAnswerId}`,
          method: 'GET',
          params: arg?.params,
        };
      },
    }),
    continueChat: builder.mutation<any, ContinueChatRequest>({
      query(arg) {
        return {
          url: `/hub/bot/api/v1/continue-chat/${arg?.sessionId}`,
          params: arg?.params,
          body: arg.body,
          method: 'POST',
        };
      },
    }),
    startBotSession: builder.mutation<any, StartBotSessionRequest>({
      query(arg) {
        return {
          url: `/hub/bot/api/v1/start-bot-session`,
          params: arg.params,
          body: arg.body,
          method: 'POST',
        };
      },
    }),
  }),
});

export const {
  useLazyGetSurveyFormByIdQuery,
  useSubmitSurveyFormMutation,
  useContinueChatMutation,
  useLazyGetSurveyFormAnswerByIdQuery,
  useStartBotSessionMutation,
} = SurveyFormsApi;
